export enum PriceCalendarEndpoints {
  FILTERS = '/filters',
  MONTHLY = '/monthly',
  FROM_PRICES = '/from-prices'
}
